import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { API_MODULES } from '@lib/api/constants';
import DIContainer from '@lib/dicontainer';

const usecase = DIContainer.getLegalUseCase();

export const legalKey = [API_MODULES.LEGAL];

export const legalCurrentOptions = () =>
  queryOptions({
    queryKey: [...legalKey, 'current'],
    queryFn: ({ signal }) => usecase.current(signal),
    staleTime: 60000,
  });

export const legalStatusOptions = (accountId: string) =>
  queryOptions({
    queryKey: [...legalKey, 'status', accountId],
    queryFn: ({ signal }) => usecase.status(signal),
    enabled: Boolean(accountId),
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  });

export const legalDocumentOptions = (revisionId?: string) =>
  queryOptions({
    queryKey: [...legalKey, 'document', revisionId ?? 'current'],
    queryFn: async ({ signal }) =>
      revisionId
        ? usecase.document(revisionId, signal)
        : (await usecase.current(signal)).document,
  });

export const acceptLegalOptions = () =>
  mutationOptions({
    mutationFn: (revisionId: string) => usecase.accept(revisionId),
  });
